
import { Input } from "../input"
import {
    NavbarContainer,
    IconContainer,
    ActionsContainer,
    NotificationIconContainer,
    FormContainer
} from './dashboard-navbar.style'
import { Avatar } from "@material-ui/core"
import { MdSearch, MdNotificationsNone, MdMenu } from "react-icons/md";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Link } from "react-router-dom";

//Search schema
const schema = yup.object().shape({
    text: yup.string().required("Type in something..."),
});



const DashboardNavbar = ({ toggle }) => {
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <NavbarContainer>
            <IconContainer>
                <MdMenu fontSize="large" onClick={toggle} />
            </IconContainer>
            <ActionsContainer>
                <FormContainer onSubmit={handleSubmit(onSubmit)}>
                    <Input
                        startAdornment={<MdSearch />}
                        placeholder='Search'
                        className="search"
                        {...register("text")}
                        error={errors.text?.message}
                    />
                </FormContainer>
                <NotificationIconContainer>
                    {/* <IconButton > */}
                    <MdNotificationsNone fontSize="large" />
                    {/* </IconButton> */}
                </NotificationIconContainer>
                <div>
                    <Link to="/account">
                        <Avatar alt="Name" src="/assets/images/avatar.jpg" sx={{ width: 32, height: 32 }} />
                    </Link>
                </div>
            </ActionsContainer>
        </NavbarContainer>
    )
}

export { DashboardNavbar }
